var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsObject, IsOptional, IsSemVer, IsString, IsUUID, MaxLength, MinLength, } from 'class-validator';
import { OfficeLocationStub } from '../../offices/dto/office-location-stub.dto.js';
import { OfficeLocationFullSizeDto } from '../../offices/dto/office-location.full-size.dto.js';
import { OfficeLiteDto } from '../../offices/dto/office.lite.dto.js';
import { Role } from '../../roles/index.js';
export class UserLiteDto {
    id;
    keycloakId;
    createdAt;
    updatedAt;
    deletedAt;
    officeId;
    currentOfficeLocationId;
    email;
    firstName;
    lastName;
    birthdate;
    mobilePhone;
    profileImage;
    diagnosisToken;
    diagnosisTokenCreatedAt;
    notes;
    registeredAt;
    street;
    zip;
    town;
    industry;
    website;
    krankenkasse;
    pkvInsurerName;
    pkvPolicyNumber;
    salutation;
    role;
    therapyArea;
    therapistId;
    agreedTermsConditions;
    dateAgreedTermsConditions;
    agreedTermsConditionsType;
    isArchived;
    countryCode;
    agreedConsentfile;
    ownedOfficeLocations;
    allowedOfficeLocations;
    office;
    officeLocation;
    currentOfficeLocation;
    isOnboarded;
    agreedNewsletter;
    lastVersion;
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], UserLiteDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsOptional(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "keycloakId", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], UserLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], UserLiteDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "deletedAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "officeId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "currentOfficeLocationId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], UserLiteDto.prototype, "email", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "lastName", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "birthdate", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "mobilePhone", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "profileImage", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "diagnosisToken", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "diagnosisTokenCreatedAt", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "notes", void 0);
__decorate([
    IsDateString(),
    Expose({
        groups: [Role.SUPERADMIN, Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT],
    }),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "registeredAt", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "street", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    MinLength(4),
    MaxLength(5),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "zip", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "town", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "industry", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "website", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "krankenkasse", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "pkvInsurerName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "pkvPolicyNumber", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "salutation", void 0);
__decorate([
    IsEnum(Role),
    Expose(),
    __metadata("design:type", String)
], UserLiteDto.prototype, "role", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "therapyArea", void 0);
__decorate([
    IsOptional(),
    Expose(),
    IsUUID(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "therapistId", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], UserLiteDto.prototype, "agreedTermsConditions", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "dateAgreedTermsConditions", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "agreedTermsConditionsType", void 0);
__decorate([
    IsBoolean(),
    Expose({
        groups: [Role.SUPERADMIN, Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT],
    }),
    __metadata("design:type", Boolean)
], UserLiteDto.prototype, "isArchived", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "countryCode", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], UserLiteDto.prototype, "agreedConsentfile", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeLocationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserLiteDto.prototype, "ownedOfficeLocations", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeLocationStub),
    Expose({
        groups: [Role.SUPERADMIN, Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT],
    }),
    __metadata("design:type", Array)
], UserLiteDto.prototype, "allowedOfficeLocations", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLiteDto),
    Exclude(),
    __metadata("design:type", Function)
], UserLiteDto.prototype, "office", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLocationFullSizeDto),
    Exclude(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "officeLocation", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLocationFullSizeDto),
    Exclude(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "currentOfficeLocation", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UserLiteDto.prototype, "isOnboarded", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Boolean)
], UserLiteDto.prototype, "agreedNewsletter", void 0);
__decorate([
    IsSemVer(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], UserLiteDto.prototype, "lastVersion", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], UserLiteDto.prototype, "fullName", null);
//# sourceMappingURL=user.lite.dto.js.map